import { Component } from "react";
import Loader from "../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../utils/withRouter";
import moment from "moment";
import { connect } from "react-redux";
import Pagination from "../../utils/pagination";
import {
  toastError,
  responseError,
} from "../../utils/constants";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { fill_action } from "../../actions/common_action/fillList_action";
import * as XLSX from 'sheetjs-style';
import Header from "../../common_components/Header";
import { get_report_details_action, get_dynamic_report_action, get_dynamic_fillList_action } from "../../actions/report_action/report_action";
import Footer from "../../common_components/Footer";
import MobileHeader from "../../common_components/mobileHeader";

const customStyles = {
  control: (provided) => ({
    ...provided,
    borderColor: "#c9c9c9",
    boxShadow: "none",
    "&:hover": {
      borderColor: "#80bdff",
    },
  }),
  multiValue: (provided) => ({
    ...provided,
    borderRadius: "14px",
    padding: "4px",
    backgroundColor: "#00BCD4",
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "white",
    fontSize: "12px",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "white",
    "&:hover": {
      backgroundColor: "#00BCD4",
      color: "#fff",
    },
  }),
};
class reportGenerator extends Component {
  // intialize constructor
  constructor(props) {
    super(props);
    this.state = {
      reportName: "",
      report_id: "",
      reportParamList: [],
      reportList: [],
      venueList: [],
      venueId: "",
      venueName: "",
      isLoading: false,
      showTable: false,
      isAccordionExpanded: false,
      startDate: "",
      endDate: "",
      list: [],
      columnArr: [],
      rowArr: [],
      xlrowArr: [],
      currentPage: 1,
      report_sp: '',
    };

    this.updateItem = this.updateItem.bind(this);
  }

  componentDidMount() {

    if (JSON.parse(sessionStorage.getItem("AwardsUserLoginData")) == null) {
      this.props.navigate("/login");
      return;
    }

    if (sessionStorage.getItem("role_id") == 2) {
      this.props.navigate("/juryDashboard");
      return;
    }

    this.setState({
      reportName:
        this.props.location.state != null &&
          this.props.location.state.reportName != null
          ? this.props.location.state.reportName
          : "",
      report_id:
        this.props.location.state != null &&
          this.props.location.state.report_id != null
          ? this.props.location.state.report_id
          : "",
    }, () => this.getReportDtl());
  }
  async getReportDtl() {
    const { report_id } = this.state;
    this.setState({ isLoading: true });

    try {
      const data = await this.props.get_report_details_action(report_id);
      this.setState({ isLoading: false });

      if (data.error !== 1) {
        console.log(data.data, 'report');

        this.setState({
          reportParamList: data.data,
          report_sp: data?.data?.[0]?.report_sp
        }, () => this.getDynamicReport());

        data.data.forEach((param) => {
          if (param.ParameterSP) {
            this.getDynamicFillList(param.ParameterSP);
          }
        });

      } else {
        responseError(data);
      }
    } catch (err) {
      this.setState({ isLoading: false });
      console.log(err);
    }
  }

  getDynamicReport(selectedParams) {
    const { report_sp } = this.state;
    this.setState({ isLoading: true })
    this.props.get_dynamic_report_action(report_sp, selectedParams)
      .then((data) => {
        this.setState({ isLoading: false })
        if (data.error != 1) {
          console.log(data.data, 'report')
          this.setState({
            isLoading: false, reportList: data.data
          })
        }
        else {
          this.setState({ isLoading: false })
          responseError(data)
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false })

        console.log(err)
      })
  }
  getDynamicFillList(parameterSP) {
    this.setState({ isLoading: true });

    this.props.get_dynamic_fillList_action(parameterSP)
      .then((data) => {
        this.setState({ isLoading: false });

        if (data.error !== 1) {
          console.log(data.data, 'dynamic fill list for', parameterSP);

          this.setState((prevState) => ({
            DynamicFillList: {
              ...prevState.DynamicFillList,
              [parameterSP]: data.data,
            },
          }));
        } else {
          responseError(data);
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false });
        console.log(err);
      });
  }

  handleExport() {
    const { reportParamList, reportList } = this.state;
    const reportType = reportParamList[0]?.report_type_id;

    if (reportType === 3 && reportList?.length > 0) {
      const filteredList = reportList?.map(({ jury_id, ...rest }) => rest);

      const worksheet = XLSX.utils.json_to_sheet(filteredList);

      // Auto column widths
      const cols = Object.keys(filteredList?.[0]).map(key => ({
        wch: Math.max(key?.length, ...filteredList?.map(row => String(row[key] || '')?.length)) + 2,
      }));
      worksheet['!cols'] = cols;

      // Add borders and bold headers
      const range = XLSX.utils.decode_range(worksheet['!ref']);
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
        if (!worksheet[cellAddress]) continue;

        worksheet[cellAddress].s = {
          font: { bold: true },
          border: {
            top: { style: 'thin', color: { rgb: '000000' } },
            bottom: { style: 'thin', color: { rgb: '000000' } },
            left: { style: 'thin', color: { rgb: '000000' } },
            right: { style: 'thin', color: { rgb: '000000' } },
          },
        };
      }

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Report');
      XLSX.writeFile(workbook, 'report.xlsx');
    } else {
      alert('No data to export or invalid report type.');
    }
  }


  onViewClick() {
    const { selectedValues, reportParamList } = this.state;

    for (let filter of reportParamList) {
      const paramName = filter.parameter_name.replace("@", "");
      const selectedValue = selectedValues?.[paramName];

      const isEmpty =
        selectedValue === undefined ||
        selectedValue === null ||
        selectedValue === "" ||
        (Array.isArray(selectedValue) && selectedValue.length === 0);

      if (filter.is_mandatory == 1 && isEmpty) {
        toastError(`Please Enter ${filter.Parameter_display_name}`);
        return; // stop further execution
      }
    }

    // All validations passed
    this.getDynamicReport(selectedValues);
  }
  navigateReportList() {
    this.props.navigate('/reportList')
  }
  renderTable(currentList) {
    console.log(currentList, 'currentList');

    // If there's no data, show the "Record not found" row
    if (!currentList || currentList?.length === 0) {
      return (
        <div className="table-responsive mb-4">
          <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
            <thead>
              <tr><th>No Data</th></tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ textAlign: "center" }}>Record not found</td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }

    // Define fields to exclude
    const excludeFields = [
      'jury_id', 'user_id', 'is_active', 'created_by_id', 'created_by_user',
      'created_date', 'modified_by_id', 'modified_by_user', 'modified_date',
      'deleted_by_id', 'deleted_by_user', 'deleted_date', 'seq_no',
      'profile_image', 'profile_filepath'
    ];

    const headers = Object.keys(currentList[0]).filter(
      (key) =>
        !excludeFields.includes(key) && !key.toLowerCase().includes('id')
    );

    return (
      <div className="table-responsive mb-4">
        <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
          <thead>
            <tr>
              {headers.map((header) => (
                <th key={header}>
                  {header
                    .replace(/_/g, ' ')
                    .replace(/\b\w/g, (char) => char.toUpperCase())}
                </th>
              ))}

            </tr>
          </thead>
          <tbody>
            {currentList.map((row, i) => (
              <tr key={i}>
                {headers.map((key) => {
                  const value = row[key];
                  const formattedValue =
                    typeof value === "string" && /^\d{4}-\d{2}-\d{2}T/.test(value)
                      ? moment(value).format("DD-MM-YYYY")
                      : value;

                  return <td key={key}>{formattedValue}</td>;
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }



  updateItem(item) {
    this.setState({ currentPage: item });
  }

  handleback() {
    this.props.navigate("/reportParamList");
  }

  render() {
    const {
      isLoading,
      rowArr,
      isAccordionExpanded,
      currentPage,
      showTable,
      xlrowArr,
      columnArr,
      list, reportParamList, reportList, DynamicFillList,
    } = this.state;
    const recordsPerPage = 10;
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = reportList?.slice(indexOfFirstRecord, indexOfLastRecord);
    const nPages = Math.ceil(reportList?.length / recordsPerPage);
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        <main id="main">

          <div className="website-view">
            <Header data={[8]} />
          </div>
          <div className="mobile-view">
            <MobileHeader data={[8]} />
          </div>
          <section class='header_margin_top'>
            <div className="container-fluid">
              <div className="row ">
                <div className="col-6 text-end">
                  <div class="page-header m-2">
                    <h2 className="mb-1 dashboard-tit  py-0 blog-name"><a title="Back" onClick={() => this.navigateReportList()}>Report</a> - {reportParamList?.[0]?.ReportName}</h2>
                  </div>
                </div>

              </div>
              <div className="search_accordion search_card">
                <div className="panel-group" id="accordion">
                  <div className="panel panel-default">
                    <div
                      className="panel-heading accordion-toggle collapsed"
                      data-toggle="collapse"
                      data-parent="#accordion"
                      data-target="#collapseOne"
                      aria-expanded={isAccordionExpanded}
                      onClick={() =>
                        this.setState({
                          isAccordionExpanded: !isAccordionExpanded,
                        })
                      }
                    >
                      <h4 className="panel-title">Search</h4>

                      <div className="searched_items">
                        {reportParamList?.length > 0 ? reportParamList?.map((filters) => {
                          const paramName = filters.parameter_name.replace("@", "");
                          const rawOptions = DynamicFillList?.[filters?.ParameterSP] || [];
                          const selectedValue = this.state.selectedValues?.[paramName];

                          let displayValue = '';

                          if (Array.isArray(selectedValue)) {
                            displayValue = selectedValue.map(val => val.label || val.value).join(', ');
                          } else if (typeof selectedValue === 'object' && selectedValue !== null) {
                            displayValue = selectedValue.label || selectedValue.value;
                          } else {
                            displayValue = rawOptions.find(opt => opt.Value == selectedValue)?.Label || selectedValue;
                          }
                          console.log(selectedValue, 'selecteddddddddd')
                          return (
                            <>
                              {(selectedValue) && (
                                <h5>
                                  {filters.Parameter_display_name}
                                  <span style={{ marginLeft: '10px', fontWeight: 'normal', color: '#555' }}>
                                    {displayValue}
                                  </span>
                                </h5>
                              )}
                            </>
                          );
                        }) : null}

                      </div>
                    </div>
                    <div
                      id="collapseOne"
                      className={`panel-collapse collapse ${isAccordionExpanded ? "show" : ""
                        }`}
                      aria-labelledby="headingOne"
                    >
                      <div className="panel-body">
                        <div className="row mr_0">
                          {reportParamList?.length > 0 &&
                            reportParamList.map((filters, index) => {
                              const paramName = filters.parameter_name.replace("@", "");
                              const selectedValue = this.state.selectedValues?.[paramName];

                              // Reconstruct actual SP with current selected values
                              let actualSP = filters.ParameterSP || "";
                              if (typeof actualSP === "string") {
                                Object.keys(this.state.selectedValues || {}).forEach((key) => {
                                  const placeholder = `@${key}`;
                                  const value = this.state.selectedValues[key];

                                  let replacedValue;
                                  if (Array.isArray(value)) {
                                    // Handle multiselect as comma separated
                                    replacedValue = value.map((v) => v.value || v).join(",");
                                  } else if (typeof value === "string" || typeof value === "number") {
                                    replacedValue = value;
                                  } else {
                                    replacedValue = "null";
                                  }

                                  actualSP = actualSP.replace(placeholder, replacedValue || "null");
                                });
                              }

                              const rawOptions = this.state.DynamicFillList?.[actualSP] || [];
                              const options = rawOptions.map((item) => ({
                                Value: item.code || item.Value,
                                Display: item.description || item.Display,
                              }));

                              return (
                                <div className="col-md-2 ml-4" key={index}>
                                  <div className="form-group">
                                    <label>
                                      {filters.Parameter_display_name}
                                      {filters.is_mandatory === "1" && (
                                        <span style={{ color: "red" }}>*</span>
                                      )}
                                    </label>

                                    {/* SINGLE SELECT */}
                                    {filters.control_type === "singleselect" && (
                                      <select
                                        className="form-select"
                                        name={paramName}
                                        value={selectedValue || ""}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          this.setState(
                                            (prev) => ({
                                              selectedValues: {
                                                ...prev.selectedValues,
                                                [paramName]: value,
                                              },
                                            }),
                                            () => {
                                              // Cascade child
                                              if (filters.child_id && filters.child_id !== "0") {
                                                const childParam = reportParamList.find(
                                                  (p) => p.parameter_name === filters.child_id
                                                );

                                                if (childParam && childParam.ParameterSP) {
                                                  let newSP = childParam.ParameterSP;

                                                  Object.keys(this.state.selectedValues || {}).forEach((key) => {
                                                    const placeholder = `@${key}`;
                                                    let replaceVal = this.state.selectedValues[key] || "null";
                                                    if (Array.isArray(replaceVal)) {
                                                      replaceVal = replaceVal.map((v) => v.value || v).join(",");
                                                    }
                                                    newSP = newSP.replace(placeholder, replaceVal);
                                                  });

                                                  this.getDynamicFillList(newSP);
                                                }
                                              }
                                            }
                                          );
                                        }}
                                      >
                                        <option value="">Select</option>
                                        {options.map((opt, i) => (
                                          <option key={i} value={opt.Value}>
                                            {opt.Display}
                                          </option>
                                        ))}
                                      </select>
                                    )}

                                    {/* MULTI SELECT */}
                                    {filters.control_type === "multiselect" && (
                                      <Select
                                        isMulti
                                        name={paramName}
                                        options={options.map((opt) => ({
                                          value: opt.Value,
                                          label: opt.Display,
                                        }))}
                                        styles={customStyles}
                                        closeMenuOnSelect={false}
                                        value={this.state.selectedValues?.[paramName]}
                                        onChange={(selected) => {
                                          this.setState(
                                            (prev) => ({
                                              selectedValues: {
                                                ...prev.selectedValues,
                                                [paramName]: selected,
                                              },
                                            }),
                                            () => {
                                              // Cascade child
                                              if (filters.child_id && filters.child_id !== "0") {
                                                const childParam = reportParamList.find(
                                                  (p) => p.parameter_name === filters.child_id
                                                );

                                                if (childParam && childParam.ParameterSP) {
                                                  let newSP = childParam.ParameterSP;

                                                  Object.keys(this.state.selectedValues || {}).forEach((key) => {
                                                    const placeholder = `@${key}`;
                                                    let replaceVal = this.state.selectedValues[key] || "null";
                                                    if (Array.isArray(replaceVal)) {
                                                      replaceVal = replaceVal.map((v) => v.value || v).join(",");
                                                    }
                                                    newSP = newSP.replace(placeholder, replaceVal);
                                                  });

                                                  this.getDynamicFillList(newSP);
                                                }
                                              }
                                            }
                                          );
                                        }}
                                      />
                                    )}

                                    {/* TEXT INPUT */}
                                    {filters.control_type === "text" && (
                                      <input
                                        type="text"
                                        className="form-control"
                                        maxLength={50}
                                        value={this.state.selectedValues?.[paramName] || ""}
                                        onChange={(e) => {
                                          this.setState((prev) => ({
                                            selectedValues: {
                                              ...prev.selectedValues,
                                              [paramName]: e.target.value,
                                            },
                                          }));
                                        }}
                                      />
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          <div className="col-md-1 ml-2" >
                            <div className="form-group">
                              <label>&nbsp;</label>
                              <button
                                className="btn btn-outline-info shadow-sm w-auto p-1 px-3"

                                onClick={() => this.onViewClick()}
                              >
                                View
                              </button>
                            </div>
                          </div>
                          <div className="col-md-1" >
                            <div className="form-group">
                              {reportList?.length > 0 && <>
                                <label>&nbsp;</label>
                                <button
                                  className="btn btn-outline-success   shadow-sm  w-auto p-1 px-3 mx-2"
                                  onClick={() => this.handleExport()}
                                >
                                  Download
                                </button>
                              </>}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {this.renderTable(currentRecords)}
              {reportList?.length > 0 ? (
                <Pagination
                  nPages={nPages}
                  currentPage={currentPage}
                  setCurrentPage={this.updateItem}
                />
              ) : (
                <></>
              )}
            </div>
          </section>
        </main >
        <Footer />

      </>
    );
  }
}

export default withRouter(
  connect(null, { fill_action, get_report_details_action, get_dynamic_report_action, get_dynamic_fillList_action })(reportGenerator)
);
